// React
import React from "react";
import PropTypes from "prop-types";
// Framework
import { usePortal } from "stack/core";
import { useStackDependency } from "stack/dependency";

////////////////////////////////////////////////////
/// Component
////////////////////////////////////////////////////

const AgentProvider = ({ options, children }) => {
  // Framework
  const { agent } = usePortal();
  // Init
  useStackDependency(agent, options);
  // Render
  return <>{children}</>;
};

AgentProvider.propTypes = {
  options: PropTypes.object,
};

export { AgentProvider };
